/**
 * Canonical key for matching model.class to background filenames.
 * Keep in sync with scripts/generate-background-manifest.mjs
 */
const UNICODE_DASHES = /[\u2010\u2011\u2012\u2013\u2014\u2015\u2212\uFE58\uFE63\uFF0D]/g;

export function normalizeBackgroundKey(text: string): string {
  let s = text.trim();
  s = s.normalize("NFKC");
  s = s.replace(UNICODE_DASHES, "-");
  s = s.replace(/_/g, "-");
  s = s.toLowerCase();
  s = s.replace(/[^a-z0-9\s-]/g, "");
  s = s.replace(/\s+/g, "-");
  s = s.replace(/-+/g, "-");
  s = s.replace(/^-+|-+$/g, "");
  return s;
}
